import React from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { Topbar } from "@components";
import styled from "styled-components";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { useTranslation } from "react-i18next";
import { localStorage } from "@utils";
import { ENGLISH_LANGUAGE_CODE_LK, BURMESE_LANGUAGE_CODE_LK } from "@constants";
import { AuthLogo } from '@assets';

const RootContainer = styled.div`
	display: flex;
	padding: 0 16px 16px 16px;
	flex-direction: column;
`;

export const Logo = styled(AuthLogo)`
 width: 100%;
`

const Title = styled.div`
padding-top: 6px;
padding-bottom: 16px;
  color: #006400;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 34px; /* 141.667% */

`;

const RulesContainer = styled.div`
  color: #4F4F4F;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */
  padding: 0 16px;
  margin: 0;

  ul {
	padding-inline-start: 0 !important;
  }

`;

const Rules = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { state } = useLocation();
	const userPreferedLanguage = localStorage.getUserPreferedLanguage();

	const goBack = () => {
		navigate(`/${PUBLIC_ROUTE.SPIN_HOME}`);
	};

	if (!state) {
		return <Navigate to={`/${PUBLIC_ROUTE.SPIN_HOME}`} />;
	}

	const ruleText =
		userPreferedLanguage === ENGLISH_LANGUAGE_CODE_LK
			? state.text_en
			: userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK
			? state.text_mm
			: state.text_ch;
	return (
		<>
			<Topbar title={t("spin.rule")} goBack={goBack} shadow={false} />
			<RootContainer>
				<Logo />
				<Title> {t("spin.ruleTitle")} </Title>
				<RulesContainer dangerouslySetInnerHTML={{ __html: ruleText }} />
			</RootContainer>
		</>
	);
};

export default Rules;
